import React, { forwardRef } from 'react';
import type { ButtonProps as ChakraCloseButtonProps } from '@chakra-ui/react';
import { IconButton as ChakraIconButton } from '@chakra-ui/react';
import { LuX } from 'react-icons/lu';

export interface CloseButtonProps extends ChakraCloseButtonProps {}

export const CloseButton = forwardRef<HTMLButtonElement, CloseButtonProps>((props, ref) => (
  <ChakraIconButton variant='ghost' aria-label='Close' ref={ref} {...props}>
    {props.children ?? <LuX />}
  </ChakraIconButton>
));
